<mat-toolbar class="footer" color="primary">
  <span>
    © {{ today | date: "yyyy" }} CargoTrans S.A. Todos los derechos reservados
  </span>
</mat-toolbar>
